import { PageResponse } from "..";
import { Player } from ".";

export class Session {
    id?: string;
    transaction?: string;
    startTime?: Date;
    endTime?: Date;
    disconnectTime?: Date;
    status?: string;
    player?: Player;
}


export class SessionResponse extends PageResponse {
    content: Session[];
}
